/**
 * Helper function to deep merge JSON Schemas.
 * IMPORTANT:
 * cloning schemas (different references will lead to side effects in json-schema-to-typescript package generating interfaces
 * If you get an error like this: IInterfaceName1, IInterfaceName2, IInterfaceName3 for the same interface ensure that its not cloned
 */
export function mergeSchemas(schemas) {
    if (schemas.length < 2) {
        throw new Error('Must contain at least two schemas');
    }
    if (schemas.some((schema) => schema === undefined || schema === null)) {
        throw new Error('Unable to merge empty schema copy');
    }
    return schemas.reduce((mergedSchema, schema) => {
        for (const key in schema) {
            if (Object.prototype.hasOwnProperty.call(schema, key)) {
                if (!Object.prototype.hasOwnProperty.call(mergedSchema, key)) {
                    mergedSchema[key] = schema[key];
                }
                else {
                    if (Array.isArray(mergedSchema[key]) && Array.isArray(schema[key])) {
                        mergedSchema[key] = [...new Set([...mergedSchema[key], ...schema[key]])];
                        mergedSchema[key].sort();
                    }
                    else if (typeof mergedSchema[key] === 'object' && typeof schema[key] === 'object') {
                        mergedSchema[key] = { ...mergedSchema[key], ...schema[key] };
                    }
                    else {
                        mergedSchema[key] = schema[key];
                    }
                }
            }
        }
        return mergedSchema;
    }, {});
}
//# sourceMappingURL=mergeSchemas.js.map